'use strict'

import {
  Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
  html
} from '@polymer/polymer/lib/utils/html-tag.js'

import '@polymer/iron-icons/iron-icons'
import '@polymer/paper-fab/paper-fab'

Polymer({
  is: 'moskito-paper-fab',
  _template: html`
  <style>
  paper-fab {
    position: relative;
  }
  .open,.overlay {
    position: var(--paper-fab-speed-dial-position, absolute);
    bottom: var(--paper-fab-speed-dial-bottom, 16px);
    right: var(--paper-fab-speed-dial-right, 16px);
  }

  .open {
    --paper-fab-background: var(--paper-fab-speed-dial-background);
    --paper-fab-keyboard-focus-background: var(--paper-fab-speed-dial-keyboard-focus-background);
  }

  .close {
    --paper-fab-background: var(--paper-fab-speed-dial-background-close, var(--paper-grey-500));
    --paper-fab-keyboard-focus-background: var(--paper-fab-speed-dial-keyboard-focus-background-close, var(--paper-grey-500));
    margin-top: 20px;
    display: inline-block;
    bottom: 0px;
    right: 0px;
  }

  .overlay {
    text-align: right;
  }
  </style>
    <paper-fab icon="[[icon]]" class="open" on-tap="open" hidden$="[[opened]]" disabled$="[[disabled]]"></paper-fab>
    <div class="overlay" id="overlay" hidden="true">
      <slot></slot>
      <paper-fab icon="close" class="close" on-tap="close"></paper-fab>
    </div>
  `,
  properties: {
    icon: {
      type: String,
      value: 'add'
    },
    opened: {
      type: Boolean,
      notify: true
    },
    closed: {
      type: Boolean,
      notify: true,
      value: false
    },
    disabled: {
      type: Boolean,
      value: false
    }
  },

  // Public methods
  open: function (e) {
    // Required for mobile Safari to avoid passing the tap event to an element below the FAB
    if (e) {
      e.preventDefault()
    }
    this.$.overlay.hidden = false
    this.opened = true
  },
  close: function (e) {
    // Required for mobile Safari to avoid passing the tap event to an element below the FAB
    if (e) {
      e.preventDefault()
    }
    this.$.overlay.hidden = true
    this.opened = false
  }
})
